import { render } from "./UtilityWrapper.vue?vue&type=template&id=12d74cb2"
import script from "./UtilityWrapper.vue?vue&type=script&lang=js"
export * from "./UtilityWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__